"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clone = _interopRequireDefault(require("lodash/clone"));
var _compact = _interopRequireDefault(require("lodash/compact"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var groupFollowingElementsByTag = function groupFollowingElementsByTag(elements, newTag, targetTag, forceStartTag, forceEndTag) {
  if ((0, _isEmpty.default)(elements) || !(0, _isArray.default)(elements)) return elements;
  if (!newTag) return elements;
  if (typeof targetTag === "string" && !targetTag) return;
  var targetArr = typeof targetTag === "string" ? [targetTag] : targetTag;

  // clone arr

  var copy = (0, _clone.default)(elements);
  var groups = [];
  var lastID = null;
  copy.forEach(function (element, copyIndex) {
    var id = element.id,
      tag = element.tag;
    if ((forceStartTag ? forceStartTag === tag : targetArr.indexOf(tag) > -1) && lastID === null) {
      // is start element

      groups.push({
        id: id,
        copyIndex: copyIndex,
        elements: [element]
      });
      lastID = id;
    } else if ((targetArr.indexOf(tag) > -1 || targetArr.indexOf("*") > -1) && forceEndTag !== tag && lastID) {
      // following elements

      var index = groups.findIndex(function (group) {
        return group.id === lastID;
      });
      groups[index].elements.push(element);
      copy[copyIndex] = null;
    } else if (forceEndTag === tag) {
      // element === endTag, for example: dropdown end

      copy[copyIndex] = null;
      lastID = null;
    } else {
      // other element -> remove lastID

      lastID = null;
    }
  });
  groups === null || groups === void 0 ? void 0 : groups.forEach(function (group) {
    var id = group.id,
      copyIndex = group.copyIndex,
      elements = group.elements;
    if (elements.length > 1) {
      copy[copyIndex] = {
        id: id,
        tag: newTag,
        children: elements
      };
    }
  });
  return (0, _compact.default)(copy);
};
var _default = groupFollowingElementsByTag;
exports.default = _default;